import RedGridLayout from "./RedGridLayout";
import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import BodyWidgetMenu from './graph/BodyWidgetMenu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionSummary from '@mui/material/AccordionSummary';
import { CanvasWidget } from '@projectstorm/react-canvas-core';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Badge, CardActions, useTheme } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Accordion from '@mui/material/Accordion';
import { TrayWidget } from './TrayWidget';
import RawMetricProperties from 'features/rawMetric/rawMetric-properties';
import MediaProperties from 'features/media/media-properties';
import PlayerProperties from 'features/player/player-properties';
import ContentHouseProperties from 'features/contentHouse/contentHouse-properties';
import { TrayItemWidget } from './TrayItemWidget';
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import { DemoCanvasWidget } from './graph/DemoCanvasWidget';
import { useEffect, useState } from 'react';
import { MetricsApplication } from './graph/MetricsApplication';
import { MetricsNodeModel, MetricsPorts } from './graph/MetricsNodeModel';
import { getHashColor } from './graph/metrics_util';
import { Browser, MetricStep, OperatingSystems, RawMetricKeys } from 'features/enumerations';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { queryGraph } from './graph/util';
import { MetricCursor, MetricDeployment, MetricGraphScreen, MetricPeriod, MetricResult, MetricGraphScreenProperties } from "models";
import {
    Button, ButtonGroup, Checkbox, FormControl, FormGroup,
    InputLabel, MenuItem, Select, Stack, TextField, CircularProgress,
    Stepper, Step, StepLabel, Grid, Box
} from '@mui/material';
import { uuid } from "./util";
import RedQuickPanel from "./RedQuickPanel";
import RedQuickBarGraph from "./RedQuickBarGraph";
import RedQuickDropdown from "./RedQuickDropdown";
import RedQuickTextField from "./RedQuickTextField";
import RedQuickDateTimePicker from "./RedQuickDateTimePicker";
import TitleService from "title-service";
import RedQuickColumnChart from "./RedQuickColumnChart";
import { useNavigate } from "react-router-dom";
import MetricHashView from "./MetricHashView";

export default function MetricGraphsComponent(props: {
    metricDeployments: MetricDeployment[],
    metricGraphScreens: MetricGraphScreen[],
    selectedGraphScreen: MetricGraphScreen,
    cursors: MetricCursor[],
    cursor: MetricCursor,
    period: MetricPeriod,
    periods: MetricPeriod[],
    metrics: MetricResult[],
    startTime: number,
    endTime: number,
    onResetCursors: () => void,
    onSelectPeriod: (id: string) => void,
    onSelectCursor: (id: string) => void,
    onSelectGraphScreen: (id: string) => void,
    onSelectMetricDeployment: (id: string) => void,
    onFetchResults: (args: { startTime: any, endTime: any, deploymentIds: string[] }) => void,
    onSaveGraphScreen: (graphScreen: MetricGraphScreen) => void
}) {
    let accordion_style = { maxHeight: 400, overflowY: 'auto', overflowX: 'hidden' };
    const theme = useTheme();
    const [workingScreen, setWorkingScreen] = useState<MetricGraphScreen>(init_workScreen());
    const [update, setUpdated] = useState(Date.now());
    const [fetchArgs, setFetchArgs] = useState(null);
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);
    const [metricDeploymentIds, setMetricDeploymentIds] = useState(null);
    const [cursorRefresh, setCursorRefresh] = useState(null);
    const [step, setStep] = useState(MetricStep.Hour)
    const navigate = useNavigate();
    function getStepCategories(startTime: number, step: MetricStep) {
        let count = getStepCategoryCount(step);
        let date = new Date(startTime);
        switch (step) {
            case MetricStep.Minute:
                return (new Array(count)).fill(null).map((v: string, index: number) => {
                    let date = new Date(startTime + (60 * index * 1000));
                    let minute = date.getMinutes();
                    if (index % 2 > 0) {
                        return '';
                    }
                    return `${(minute)} min`;
                })
            case MetricStep.TenMinutes:
                return (new Array(count)).fill(null).map((v: string, index: number) => {
                    let date = new Date(startTime + (index * 10 * 1000 * 60));
                    if (index % 2 > 0) {
                        return '';
                    }

                    let day = date.toLocaleTimeString();
                    return day;
                })
            case MetricStep.ThirtyMinutes:
                return (new Array(count)).fill(null).map((v: string, index: number) => {
                    let date = new Date(startTime + (index * 30 * 1000 * 60));
                    if (index % 2 > 0) {
                        return '';
                    }
                    let day = date.toLocaleTimeString();
                    return day;
                })
            case MetricStep.Hour:
                return (new Array(count)).fill(null).map((v: string, index: number) => {
                    let date = new Date(startTime + (index * 60 * 1000 * 60));
                    let minute = date.getMinutes();
                    let hours = date.getHours();
                    let day = date.toLocaleTimeString();
                    return day;
                })
            case MetricStep.Week:
            case MetricStep.FourWeek:
            case MetricStep.Day:
                return (new Array(count)).fill(null).map((v: string, index: number) => {
                    let date = new Date(startTime + (index * 24 * 60 * 1000 * 60));
                    let day = date.toLocaleDateString();
                    return day;
                });
        }
    }
    function getStepCategoryCount(step: MetricStep): number {
        switch (step) {
            case MetricStep.Minute:
                return 60;
            case MetricStep.TenMinutes:
                return 60;
            case MetricStep.ThirtyMinutes:
                return 60;
            case MetricStep.Hour:
                return 24;
            case MetricStep.Day:
                return 24;
            case MetricStep.Week:
                return 24;
            case MetricStep.FourWeek:
                return 24;

        }
        return 10;
    }

    function getTimeUnitOffsetAmount(step: MetricStep): number {
        let addAmount = 0;
        switch (step) {
            case MetricStep.Minute:
                addAmount = 60 * 1000;
                break;
            case MetricStep.TenMinutes:
                addAmount = 10 * 60 * 1000;
                break;
            case MetricStep.ThirtyMinutes:
                addAmount = 30 * 60 * 1000;
                break;
            case MetricStep.Hour:
                addAmount = 60 * 60 * 1000;
                break;
            case MetricStep.Day:
                addAmount = 24 * 60 * 60 * 1000;
                break;
            case MetricStep.Week:
                addAmount = 7 * 24 * 60 * 60 * 1000;
                break;
            case MetricStep.FourWeek:
                addAmount = 4 * 7 * 24 * 60 * 60 * 1000;
                break;

        }
        return addAmount;
    }

    function getEndingDate(startTime: number, step: MetricStep): number {
        return startTime + (getTimeUnitOffsetAmount(step) * getStepCategoryCount(step));
    }

    function init_workScreen() {
        return {
            name: '',
            deployments: {},
            deploymentViewDescription: {},
            description: '',
            layout: {},
            player: null,
            "Player-id": null,
            "Player-version": null
        };
    }
    function generateInterfaceItemWidgets() {
        return props.metricDeployments.map((d) => {
            return (
                <TrayItemWidget
                    key={d.id}
                    model={{ type: d.id }}
                    name={d.name} color={getHashColor(d.id)} />
            )
        });
    }
    function stepToMillseconds(step: string | number) {
        return parseFloat(`${step}`) * 1000;
    }
    useEffect(() => {
        if (!startTime)
            setStartTime((Date.now()));
        if (!endTime)
            setEndTime(getEndingDate(startTime, step));
    }, [])
    useEffect(() => {
        setWorkingScreen((JSON.parse(JSON.stringify(props.selectedGraphScreen))));
        if (props?.selectedGraphScreen?.deploymentViewDescription) {
            let ids = [];
            Object.entries(props?.selectedGraphScreen?.deploymentViewDescription).map((v) => {
                if (ids.indexOf(v[1].deploymentId) === -1)
                    ids.push(v[1].deploymentId);
            });

            setMetricDeploymentIds(ids);
        }
    }, [props?.selectedGraphScreen?.id]);
    useEffect(() => {
        setUpdated(Date.now());

    }, [props?.metrics?.length])
    useEffect(() => {
        setEndTime(props.endTime);
        setStartTime(props.startTime);
        setFetchArgs({
            ...(fetchArgs || {}),
            endTime: props.endTime,
            startTime: props.startTime,
        })
    }, [props.endTime, props.startTime]);
    useEffect(() => {

        setFetchArgs({
            ...(fetchArgs || {}),
            endTime: endTime,
            startTime: startTime,
        });
        setUpdated(Date.now());
    }, [endTime, startTime]);

    useEffect(() => {
        if (fetchArgs?.startTime && fetchArgs?.endTime) {
            props.onFetchResults({
                ...fetchArgs,
                deploymentIds: metricDeploymentIds
            })
        }
    }, [metricDeploymentIds, fetchArgs])
    // useEffect(() => {
    //     if (fetchArgs?.startTime && fetchArgs?.endTime && fetchArgs?.deploymentIds) {
    //         props.onFetchResults({
    //             ...fetchArgs
    //         })
    //     }
    // }, [fetchArgs])
    return (
        <S.Body>
            <S.Header>
                <Button type="button" key={'buton'} onClick={() => {
                    navigate(-1);
                }} className="btn btn-tool" data-card-widget="collapse">

                    <ArrowBackIosIcon />
                </Button>
                <BodyWidgetMenu menuTitle={`${''}`.trim() || 'Menu'} menuItems={[{
                    title: 'New',
                    handler: () => {
                        setWorkingScreen(init_workScreen())
                    }
                }, {
                    handler: async () => {
                        props.onSaveGraphScreen(workingScreen)
                    },
                    title: workingScreen?.id ? 'Save' : 'Save New'
                }, {
                    handler: async () => {

                    },
                    title: 'Delete'
                }]} />
                <BodyWidgetMenu menuTitle={'Options'} menuItems={[{
                    title: 'Jump to first',
                    handler: () => {
                        if (props?.metrics?.length) {
                            let sorted = [...props.metrics].sort((a, b) => {
                                return a.time - b.time;
                            });
                            if (sorted[0]) {
                                setStartTime(sorted[0].time);
                            }
                        }
                    }
                }, {
                    title: 'Refresh',
                    handler: () => {
                        setUpdated(Date.now());
                    }
                }].filter(x => x)} />
            </S.Header>
            <S.Content>
                <TrayWidget>
                    <RedQuickDropdown key={` =asdfasd`}
                        options={Object.entries(MetricStep).map(val => {
                            if (val) {
                                return {
                                    title: val[0],
                                    value: val[1],
                                    label: val[0]
                                }
                            }
                        }).filter(x => x)}
                        onChange={(val: string) => {

                            setStep(val);
                            // let period = deploymentPeriods.find(v => v.step === val)
                            // let cursor = props.cursors.find(x => x.owner === period?.id)
                            // setCursorRefresh(cursor?.id);
                            setFetchArgs({
                                startTime,
                                endTime: getEndingDate(startTime, val as MetricStep),
                                ...(fetchArgs || {})
                            });
                            setUpdated(Date.now());
                        }}
                        value={step} />
                    <ButtonGroup size="large" variant="text" color="inherit" sx={{ border: '1px solid', borderColor: 'grey.400' }}>
                        <Button type="button" key={'buton'} onClick={() => {
                            if (props.metrics) {
                                let offset = stepToMillseconds(step) * getStepCategoryCount(step) / 2;
                                setEndTime(endTime - offset)
                                setStartTime(startTime - offset);
                            }
                        }} className="btn btn-tool" data-card-widget="collapse">
                            <ArrowBackIosIcon />
                        </Button>

                        <Button type="button" key={'buton'} onClick={() => {
                            let offset = getEndingDate(Date.now(), step);
                            setEndTime(Date.now())
                            setStartTime(Date.now() - stepToMillseconds(step) * getStepCategoryCount(step));
                        }} className="btn btn-tool" data-card-widget="collapse">
                            <CheckBoxOutlineBlankIcon />
                        </Button>

                        <Button type="button" key={'buton'} onClick={() => {
                            if (props.metrics) {
                                let offset = stepToMillseconds(step) * getStepCategoryCount(step) / 2;
                                setEndTime(endTime + offset);
                                setStartTime(startTime + offset);
                            }
                        }} className="btn btn-tool" data-card-widget="collapse">
                            <ArrowForwardIosIcon />
                        </Button>
                    </ButtonGroup>
                    <FormGroup>
                        <TextField
                            margin="dense"
                            fullWidth
                            variant="standard"
                            onChange={(evt) => {
                                setWorkingScreen({
                                    ...workingScreen,
                                    name: evt.currentTarget.value

                                })
                            }}
                            value={workingScreen?.name} />
                        <RedQuickDateTimePicker disabled label={TitleService('Start')} onChange={(val) => {
                        }} value={startTime} />
                        <RedQuickDateTimePicker label={TitleService('End')} onChange={(val) => {
                            if (val?.getTime)
                                setStartTime(val.getTime() - (getTimeUnitOffsetAmount(step) * getStepCategoryCount(step)))
                        }} value={getEndingDate(startTime, step)} />
                    </FormGroup>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Deployments</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ ...accordion_style }}>
                            <div>
                                {generateInterfaceItemWidgets()}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Graphs</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ ...accordion_style }}>
                            <div>
                                {(props.metricGraphScreens || []).map((configuration, i: number) => {
                                    return (
                                        <ListItem key={`asdf-${i}`} disablePadding>
                                            <ListItemButton onClick={() => {
                                                props.onSelectGraphScreen(configuration?.id);
                                            }}>
                                                <ListItemIcon>
                                                    <AccountTreeIcon color={props?.selectedGraphScreen?.id === configuration?.id ? 'success' : 'secondary'} />
                                                </ListItemIcon>
                                                <ListItemText primary={configuration?.name} />
                                            </ListItemButton>
                                        </ListItem>
                                    )
                                })}
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </TrayWidget>
                <S.Layer onDrop={async (event) => {
                    try {
                        var data = JSON.parse(event.dataTransfer.getData('storm-diagram-node'));
                        props.onSelectMetricDeployment(data.id);
                        let id = uuid();
                        if (workingScreen?.layout && workingScreen?.deploymentViewDescription && data) {
                            setWorkingScreen({
                                ...workingScreen,
                                deploymentViewDescription: {
                                    ...workingScreen.deploymentViewDescription,
                                    [id]: {
                                        id,
                                        deploymentId: data.type,
                                        name: ''
                                    }
                                },
                                layout: {
                                    ...workingScreen.layout,
                                    [id]: {
                                        i: id,
                                        x: 0,
                                        y: 0,
                                        w: 1,
                                        h: 2
                                    }
                                }
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }}
                    onDragOver={(event) => {
                        event.preventDefault();
                    }}>
                    <RedGridLayout updated={update} onLayoutUpdate={(currentLayout) => {
                        let layoutUpdate = {};
                        if (workingScreen) {
                            currentLayout.map((l) => {
                                if (workingScreen.layout[l.i]) {
                                    layoutUpdate[l.i] = {
                                        ...l,
                                        id: l.i
                                    };
                                }
                            });

                            setWorkingScreen({
                                ...workingScreen,
                                layout: {
                                    ...workingScreen.layout,
                                    ...layoutUpdate
                                }
                            });
                        }
                    }} elements={Object.entries(workingScreen?.layout || {}).map((v) => {
                        let layout = v[1];
                        let description = workingScreen.deploymentViewDescription[v[0]];
                        let deploymentPeriods = props.periods.filter(x => x.owner === description.deploymentId);
                        // let step = workingScreen.deploymentViewDescription[v[0]].step || parseInt(MetricStep.Hour, 10);
                        let period = deploymentPeriods.find(v => v.step === step);
                        console.log('period');
                        console.log(period);
                        let cursor = props.cursors.find(x => x.owner === period?.id)
                        console.log('cursor');
                        console.log(cursor);
                        let _endTime = getEndingDate(startTime, step);
                        let categoryCount = getStepCategoryCount(`${step}` as MetricStep);

                        let categories = getStepCategories(startTime, `${step}` as MetricStep);
                        console.log('categories');
                        console.log(categories);
                        let metricGraphValues = new Array(categoryCount).fill(0);
                        let methodType = null;
                        console.log(`startTime: ${startTime}`)
                        console.log(`_endTime: ${_endTime}`)
                        console.log(`step: ${step}`)
                        let metrics = props.metrics.filter(x => {
                            return `${x.step}` === `${step}` && x.cursorId === cursor?.id && startTime <= x.time && x.time < _endTime;
                        });
                        console.log('props.metrics');
                        console.log(props.metrics);
                        metrics.forEach(v => {
                            let offset = (v.time - startTime) / (_endTime - startTime);
                            if (Object.keys(v.hashValue).length === 100) {
                                let temp = 0;
                                Object.keys(v.hashValue).forEach(g => temp += v.hashValue[g]);
                                methodType = 'HashAdd';
                                metricGraphValues[Math.round(offset * categoryCount)] = temp;
                            }
                            else {
                                methodType = 'Add';
                                metricGraphValues[Math.round(offset * categoryCount)] = v.value;
                            }
                        });
                        let title = '';
                        if (props.metricDeployments) {
                            let dep = props.metricDeployments.find(x => x.id === description.deploymentId);
                            if (dep) {
                                title = dep.name;
                            }
                        }
                        return {
                            id: v[0],
                            element: () => {
                                let body: any = null;
                                switch (methodType) {
                                    case 'HashAdd':
                                        body = <MetricHashView metrics={metrics} />
                                        break;
                                    case 'Add':
                                        body = <ParentSize>{({ width, height }) => <RedQuickColumnChart
                                            width={width}
                                            height={height}
                                            categories={categories} series={[{
                                                name: '',
                                                data: metricGraphValues
                                            }]} />}</ParentSize>;
                                        break;
                                }
                                return (
                                    <RedQuickPanel buttons={
                                        <Grid container spacing={0}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={0}>
                                                    <Grid xs={1}>
                                                        <Button type="button" key={'buton'} onClick={() => {
                                                            let layout = { ...workingScreen.layout };
                                                            let deploymentViewDescription = { ...workingScreen.deploymentViewDescription };
                                                            delete layout[v[0]];
                                                            delete deploymentViewDescription[v[0]];

                                                            setWorkingScreen({
                                                                ...workingScreen,
                                                                deploymentViewDescription: {
                                                                    ...deploymentViewDescription
                                                                },
                                                                layout: {
                                                                    ...layout
                                                                }
                                                            });
                                                        }} className="btn btn-tool" data-card-widget="collapse">
                                                            <CloseIcon />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>} title={title || 'Unknown'} updated={update} cardStyle={{ backgroundColor: '#ffffff22' }} stretch key={v[0]} >
                                        {body}
                                    </RedQuickPanel>
                                )
                            }
                        };
                    })} layout={Object.entries(workingScreen?.layout || {}).map(v => v[1])} />
                </S.Layer>
            </S.Content>
        </S.Body>
    )
}
namespace S {
    export const Body = styled.div`
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		min-height: 100%;
        height: 100vh;
	`;

    export const Header = styled.div`
		display: flex;
		background: rgb(30, 30, 30);
		flex-grow: 0;
		flex-shrink: 0;
		color: white;
		font-family: Helvetica, Arial, sans-serif;
		padding: 10px;
		align-items: center;
	`;

    export const Content = styled.div`
		display: flex;
		flex-grow: 1;
	`;

    export const Layer = styled.div`
		position: relative;
		flex-grow: 1;
	`;
}


